import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import Layout from '../../Layout';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { SpravaoUcastiVerejnosti } from '../../../module/SprievodnyDokument/CreateFromForm';
import { updateSpravaoUcastiVerejnostiClient }
  from '../../../client/external/evidencnaaplikacia/spravaoUcastiVerejnostiClient';
import useSpravaoUcastiVerejnostiFormData from './hook/useSpravaoUcastiVerejnostiFormData';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import SuccessMessages from '../../../module/SuccessMessages';
import { useClient } from '../../../context/ClientStatusContext';

const SpravaoUcastiVerejnostiEditPage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year,
    index,
    stadiumUuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadiumUuid: string }>();

  const {
    formDataResponse,
    formDataStatus,
  } = useSpravaoUcastiVerejnostiFormData(
    type,
    year,
    index,
    stadiumUuid,
  );

  const {
    wrapClient: updateSpravaoUcastiVerejnosti,
  } = useClient(updateSpravaoUcastiVerejnostiClient);

  useEffect(() => {
    if (!formDataStatus.loading) {
      setTitle(getTitle());
    }
  }, [formDataStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Správa o účasti verejnosti',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={formDataStatus.loading}>
        {formDataStatus.finished && (
          <SecuredPage
            hasOpravneniePracovneKroky={formDataResponse?.materialDetail?.hasOpravnenieSprievodneDokumenty}
            requestStatus={formDataStatus?.responseCode}
          >
            <>
              <SuccessMessages />
              {formDataResponse?.materialDetail && formDataResponse?.formData && (
              <>
                <PageHeadingWithBackButton
                  headingCaption={`Legislatívny proces ${formDataResponse.materialDetail.cisloLegislativnehoMaterialu}`}
                  heading="Správa o účasti verejnosti"
                  withBackLink
                />
                <SpravaoUcastiVerejnosti
                  onSubmit={updateSpravaoUcastiVerejnosti}
                  material={formDataResponse.materialDetail}
                  initFormData={formDataResponse.formData}
                />
              </>
              )}
            </>
          </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default SpravaoUcastiVerejnostiEditPage;
